/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { Snackbar, SnackbarContent } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { selectComposerSnackbarMessage } from "data/store/reducers/composer";
import { setSnackbarMessage } from "data/store/reducers/composer";

const SimplicitySnackbar = () => {

    const snackbarMessage = useSelector(selectComposerSnackbarMessage);
    const dispatch = useDispatch();
    const open = !!snackbarMessage;
    
    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        dispatch(setSnackbarMessage(""));
    };
    
    // useEffect(() => {
    //     if (snackbarMessage) {
    //         console.log(`new snackbarMessage: ${snackbarMessage}`)
    //     }
    // }, [snackbarMessage]);
    
    return (
        <Fragment>
            <Snackbar 
                open={open}
                autoHideDuration={2000}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
            >
                <SnackbarContent
                    style={{
                        backgroundColor: "#333333",
                        color: "#FFFFFFF",
                        borderRadius: "8px",
                        display: "flex",
                        textAlign: "center",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                    message={snackbarMessage}
                />
            </Snackbar>
        </Fragment>
    );
};

export { SimplicitySnackbar };
